// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICreateConsultingRequestRequest,
  TCreateConsultingRequestModel,
  IMappers,
  TCreateConsultingRequestResponse,
  ICreateConsultingRequestResponseError,
} from './types';

export const defaultConfig: TCreateConsultingRequestModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-flat-view-order',
  pathApi: '/v1/create-consulting-request/',
  requestType: 'json',
  responseType: 'json',
} as TCreateConsultingRequestModel;

export function createCreateConsultingRequestModel(
  parameters: ICreateConsultingRequestRequest,
): TCreateConsultingRequestModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateConsultingRequestOptions<TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400>;
  parameters: ICreateConsultingRequestRequest;
}

export async function fetchCreateConsultingRequest<TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateConsultingRequestOptions<TResponse400>): Promise<TCreateConsultingRequestResponse | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createCreateConsultingRequestModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as ICreateConsultingRequestResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCreateConsultingRequestResponse;
}
